@for (item of items(); track item) {
  <div
    class="skeleton-loader {{ containerClasses() }} {{ robotClasses() }}"
    [attr.aria-label]="ariaLabel()"
    aria-busy="true"
    aria-valuemin="0"
    aria-valuemax="100"
    [attr.aria-valuetext]="loadingText()"
    role="progressbar"
    tabindex="-1"
    [ngClass]="{
      'custom-content': appearance() === 'custom-content',
      circle: appearance() === 'circle',
      'progress-light': animation() === 'progress' && themeService.isActiveThemeLight,
      'progress-dark': animation() === 'progress' && themeService.isActiveThemeDark,
      pulse: animation() === 'pulse',
    }"
    [ngStyle]="styles()">
    @if (appearance() === 'custom-content') {
      <ng-content></ng-content>
    }
  </div>
}
